module.exports = __webpack_public_path__ + "img/market_carnival_top@1x.0802b1f7.png";